/** Split `Passengers` field on `;` for autocomplete of the segment being edited. */

export type ActivePassengerSegment = {
  /** Text before the active segment, including trailing `;` when present. */
  prefix: string;
  /** Raw segment text from last `;` (exclusive) to cursor. */
  tokenRaw: string;
  /** Text from cursor to end of value. */
  suffix: string;
  /** Trimmed token for search. */
  tokenQuery: string;
};

export function getActivePassengerSegment(
  value: string,
  cursor: number
): ActivePassengerSegment {
  const before = value.slice(0, cursor);
  const suffix = value.slice(cursor);
  const lastSemi = before.lastIndexOf(";");
  const prefix = lastSemi < 0 ? "" : value.slice(0, lastSemi + 1);
  const tokenRaw = lastSemi < 0 ? before : before.slice(lastSemi + 1);
  return {
    prefix,
    tokenRaw,
    suffix,
    tokenQuery: tokenRaw.trim(),
  };
}

export function replaceActiveToken(
  value: string,
  cursor: number,
  pickedName: string
): { newValue: string; newCursor: number } {
  const { tokenRaw, suffix } = getActivePassengerSegment(value, cursor);
  const segStart = cursor - tokenRaw.length;
  const name = pickedName.trim();
  let mid = name;
  if (segStart > 0 && value[segStart - 1] === ";" && name.length > 0) {
    mid = ` ${name}`;
  }
  const newValue = value.slice(0, segStart) + mid + suffix;
  const newCursor = segStart + mid.length;
  return { newValue, newCursor };
}
